var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-container",class:[_vm.getColor, _vm.size]},[_c('a',{staticClass:"bttn",attrs:{"href":_vm.internalHref},on:{"click":_vm.click}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }